
import * as ipxRuntime$Na2lXBPpTSI8r00fTYZjhw8jkKbRITpses12A7ShFEE from '/app/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.4_ioredis@5.11.0_magicast@0.5.3_srvx@0.11.16/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$Na2lXBPpTSI8r00fTYZjhw8jkKbRITpses12A7ShFEE, defaults: {} }
}
        